var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mz-recommendation-html-item",domProps:{"innerHTML":_vm._s(_vm.html)},on:{"click":function($event){return _vm.trackClick()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }